import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { CurrencyItem } from '@/models/dictionary/currency-list.model';

export default class GetCurrencyListRequest extends ApiResourceMethod<CurrencyItem[]> {
  public perform(): Promise<CurrencyItem[]> {
    return this.performer.requestWithMapper(
      {},
      (payload: BaseResponse<CurrencyItem[]>) => {
        return payload.data;
      },
    );
  }
}
